import React, { useEffect, useState } from "react";
import "./style.css";
import DesktopSideBar from "./../../components/DesktopSideBar";
import MobileNavbar from "../../components/MobileNavbar";
import { CircularProgress } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import {
  getDoc,
  db,
  doc,
  query,
  collection,
  getDocs,
} from "./../../config/firebase";

const Index = () => {
  const medalImage = require("./../../assets/images/awardImage.png");
  const matches = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false);
  const debug = require("debug")("myapp:server"); // DEBUG
  let [eventBtnsArray, setEventBtnsArray] = useState([]);
  let [levelOptionArray, setLevelOptionArray] = useState([]);
  let [ageGroupsArray, setAgeGroupsArray] = useState([]);
  let [routineOptionssArray, setRoutineOptionsArray] = useState([]);
  let [lastrefresh, setrefreshdate] = useState("");

  const { meetId } = useParams();

  const [allMeetData, setAllMeetData] = useState({});

  // Score Identifiers For Identifying scores.
  class ScoreIdentifier {
    // Create new instances of the same class as static attributes
    static Event_Final = new ScoreIdentifier("Event_Final", true, false, 1, "");
    static Routine_Final = new ScoreIdentifier(
      "Routine_Final",
      true,
      false,
      1,
      ""
    );
    static E_Final = new ScoreIdentifier("E_Final", false, true, 1, "E");
    static A_Final = new ScoreIdentifier("A_Final", false, true, 2, "A");
    static H_Final = new ScoreIdentifier("H_Final", false, true, 3, "H");
    static D_Final = new ScoreIdentifier("D_Final", false, true, 4, "D");
    static T_Final = new ScoreIdentifier("T_Final", false, true, 5, "T");
    static P_Final = new ScoreIdentifier("P_Final", false, true, 6, "P");
    static B_Final = new ScoreIdentifier("B_Final", false, true, 7, "B");

    constructor(name, istotalscore, issubscore, displayorder, header) {
      this.name = name;
      this.issubscore = issubscore;
      this.istotalscore = istotalscore;
      this.displayorder = displayorder;
      this.header = header;
    }
  }

  // This is event Btn
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedRoutine, setSelectedRoutine] = useState("");
  
  // Fetch Score Data
  const getMeetDetails = async () => {
    setLoading(true);
    console.log("Refreshing scores for meet:",meetId)
    if (!meetId) {
      return;
    }
    
    const docRef = doc(db, "meets", `${meetId}`);
    let meetData = await getDoc(docRef);

    // getting Managed Routines Data
    const q = query(collection(db, "meets", `${meetId}`, "managedRoutines"));
    const managedRoutinesDoc = await getDocs(q);
    const routines = [];
    managedRoutinesDoc.forEach((routineDoc) => {
      routines.push(routineDoc.data());
    });
    ///////

    // getting Managed Scores
    const qScores = query(
      collection(db, "meets", `${meetId}`, "managedScores")
    );
    const managedScoresDoc = await getDocs(qScores);
    const scores = [];
    managedScoresDoc.forEach((scoreDoc) => {
      scores.push(scoreDoc.data());
    });
    ///////
    /// Merge Managed Scores and Routines into Functional Object For UI
    var allscores = [];
    for (let i = 0; i < scores.length; i++) {
      for (let ii = 0; ii < scores[i].scores.length; ii++) {
        allscores.push(scores[i].scores[ii]);
      }
    }

    var cgroups = [];
    var events = [];
    var levels = [];
    var agegroups = [];
    var routineOptions = [];
    for (let i = 0; i < routines.length; i++) {
      const list = routines[i];
      for (let a = 0; a < list.clubs.length; a++) {
        const club = list.clubs[a];
        for (let b = 0; b < club.competitors.length; b++) {
          const competitor = club.competitors[b];
          for (let c = 0; c < competitor.events.length; c++) {
            const event = competitor.events[c];
            // Initalize an event row
            var competitoreventRow = {
              compgroup: event.event.competitionGroupID,
              eventname: event.event.name,
              agegroup: event.event.agegroup,
              level: event.event.level,
              gender: competitor.sex,
              place: null,
              name:
                competitor.competitor.firstName +
                " " +
                competitor.competitor.lastName,
              score: null,
              routines: [],
            };
            // Update event options
            events.push(event.event.name);
            levels.push(event.event.level);
            agegroups.push(event.event.agegroups);
            // Get The Total Score for the current competitorevent.
            for (let d = 0; d < allscores.length; d++) {
              if (allscores[d].scoreobjectid == event.id) {
                competitoreventRow.score = allscores[d].score.value;
                competitoreventRow.place = allscores[d].score.place;
                break;
              }
            }

            for (let d = 0; d < event.routines.length; d++) {
              const routine = event.routines[d];
              // Create Routine Row Object.
              var newroutinerow = {
                place: null,
                name: routine.name,
                subscores: [],
                totalscore: null,
              };
              // Add Routine Options
                routineOptions.push(routine.name);
              // Find the scores that belong to this routine.

              for (let e = 0; e < allscores.length; e++) {
                const managedscore = allscores[e];
                if (managedscore.scoreobjectid == routine.id) {
                  const scoredetails = managedscore.score;
                  const scoreid = ScoreIdentifier[scoredetails.id];
                  if (scoreid === undefined) {
                    continue;
                  }
                  if (scoreid.issubscore) {
                    let sobject = {
                      title: scoreid.header,
                      value: scoredetails.value,
                      displayorder: scoreid.displayorder,
                    };

                    // Add a new subscores object
                    newroutinerow.subscores.push(sobject);
                  }
                  // Update the total score for
                  if (scoreid.istotalscore) {
                    newroutinerow.place = scoredetails.place;
                    newroutinerow.totalscore = scoredetails.value;
                  }
                }
              }

              // // Sort the subscores in ascending displayorder
              newroutinerow.subscores = newroutinerow.subscores.sort(
                function (a, b) {
                  return a.displayorder - b.displayorder;
                }
              );
              // Add the newroutine to the current competitorevent
              competitoreventRow.routines.push(newroutinerow);
            }
            // Add  new competitor to the competition group
            cgroups.push(competitoreventRow);
          }
        }
      }
    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
    meetData = {
      ...meetData.data(),
      cgroups: cgroups,
    };
  setAllMeetData(meetData);
  // Set the button options
  events = [...new Set(events)];
  levels = [...new Set(levels)];
  agegroups = [...new Set(agegroups)];
  routineOptions = [...new Set(routineOptions)];
  setEventBtnsArray(events);
  setLevelOptionArray(levels)
  setAgeGroupsArray(agegroups)
  setRoutineOptionsArray(routineOptions);
  console.log([selectedEvent,selectedLevel,selectedGroup,selectedRoutine]);
  getAllGroups(selectedEvent,selectedLevel,selectedGroup,selectedRoutine);
  setrefreshdate(new Date().toLocaleString());
  setLoading(false);
  };
// Refresh Score Data
  const handleRefresh = (event) => {
      getMeetDetails();// Refresh the meet details.
  };
  // Here getting meet details complete
  useEffect(() => {
    setLoading(true);
    
    getMeetDetails();
  }, [meetId]);

  useEffect(() => {
    getAllGroups(selectedEvent,selectedLevel,selectedGroup,selectedRoutine);
  }, [allMeetData]);
  // in all Groups we will set all groups of that meets and apply functionality on it then..(e.g filterations)
  const [allGroups, setAllGroups] = useState([]);

  

  // We have all events in an array.. so setting 0th index by default initially so that we weill get data
  // of first event initialyy by default
  // on Event Btn Click
  const handleEventChange = (eventName) => {
    if (eventName === selectedEvent){ // Added if statement was just set to eventName
      setSelectedEvent("");
      eventName = "";
    } else {
      setSelectedEvent(eventName);
    }
    onEventChanges(eventName);
    getAllGroups(eventName,selectedLevel,selectedGroup,selectedRoutine);
  };

  //   all group names
  //   When there is any change in filter optoin or btns , this will execute.
  const getAllGroups = (event,level,agegroup,routine) => {
    // Create Groups that match drop down menus.
    var groups = [];
    if (allMeetData.cgroups === undefined) {
      return;
    }
    for (let a = 0; a < allMeetData.cgroups.length; a++) {
      let item = Object.assign({},allMeetData.cgroups[a]); // Create a copy of the group, so updates to routines do not update AllMeetData
      // Check filters.
      if ( event !== "" && item.eventname !== event ){
          continue;
      }
      if (level !== "" && item.level !== level){
          continue
      }
      if (agegroup !== "" && item.agegroup !== agegroup ){
          continue
      }

      
      // Update Routine Array
      item.routines = item.routines.filter((i)=>{
        if (routine === ""){return true}
        return i.name === routine
      })
      // Add Groups
      var group = undefined;
      for (let b = 0; b < groups.length; b++) {
        if (groups[b].name == item.compgroup) {
          group = groups[b];
          break;
        }
      }
      if (group === undefined) {
        const newgroup = {
          name: item.compgroup,
          competitors: [item],
        };
        groups.push(newgroup);
      } else {
        group.competitors.push(item);
      }
    }

    // Sort the competitors in each group by place ascending.
    for (let a = 0; a < groups.length; a++) {
      groups[a].competitors = groups[a].competitors.sort(function (a, b) {
        if (a.place === null){
          return 1
        }
        if (b.place === null){
          return -1
        }
        
         return a.place - b.place;
        
      });
    }
    groups = [...new Set(groups)];
    setAllGroups(groups);
  };

// View State Updates (Effects)
 

  // useEffect(() => {

  // }, [selectedEvent]);

  // useEffect(() => {
  //   console.log("Trigering level change effect")
  //   onLevelChanges();
  //   getAllGroups();
  // }, [selectedLevel]);
  
  //   for search athlete functionality
  const [noResultsFound, setNoResultsFound] = useState(false);
  const searchCompetitor = (e) => {

    if (e.target.value.length === 0) {
      // gettingAllCompetitors();
      setNoResultsFound(false);
      return;
    }
    let search = e.target.value.toLowerCase();
    var groups = [];
    if (allMeetData.cgroups === undefined) {
      return;
    }
    for (let a = 0; a < allMeetData.cgroups.length; a++) {
      let item = Object.assign({},allMeetData.cgroups[a]);
    
      // Add Groups
      var group = undefined;
      for (let b = 0; b < groups.length; b++) {
        if (groups[b].name == item.compgroup) {
          group = groups[b];
          break;
        }
      }
      if (group === undefined) {
        let gname = item.eventname + " / " + item.compgroup
        const newgroup = {
          name: gname,
          competitors: [item],
        };
        groups.push(newgroup);
      } else {
        group.competitors.push(item);
      }
    }
    // Filter CompGroups that contain the selected athlete.
    var competitorgroups = [];
    for (let a = 0; a < groups.length; a++) {
      var competitorfound = false;
      for (let b = 0; b < groups[a].competitors.length; b++) {
        let competitor = groups[a].competitors[b];
        let cname = competitor.name.toLowerCase();
        if (cname.includes(search)){
          competitorfound = true;
          break;
        }
      }
      if (competitorfound){
        competitorgroups.push(groups[a]);
      }
    }
    // Reassign groups to the filtered competitor only groups.
    
    // Sort the cmpetitors in each group by place ascending.
    for (let a = 0; a <  competitorgroups.length; a++) {
      competitorgroups[a].competitors =  competitorgroups[a].competitors.sort(function (a, b) {
        return a.place - b.place;
      });
    }
    competitorgroups = [...new Set(competitorgroups)];
    setAllGroups(competitorgroups);
    setLoading(false);
  };

  // For Accordian
  const [accordianClass, setAccordianClass] = useState("teamItem");
  const openAccordian = (e) => {
    if (!e.target.nextElementSibling) {
      return;
    }
    setAccordianClass("teamItem is-open");
    let content = e.target.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };

  ///////////////////////////////////////////////////
  // Filteration of select tag options
  const onEventChanges = (event) => {
    if (allMeetData.cgroups === undefined) {
      return;
    }
    let updatedLevels = [];
    let updatedagegroups = [];
    let routines = [];
    for (let i = 0; i < allMeetData.cgroups.length; i++) {
      let group = allMeetData.cgroups[i];
      if (group.eventname !== event && event !== ""){ continue }
      updatedLevels.push(group.level);
      updatedagegroups.push(group.agegroup);
      if (group.routines === undefined){continue}
      for (let r = 0; r < group.routines.length; r++) {
        routines.push(group.routines[r].name);
      }
    }

    updatedLevels = [...new Set(updatedLevels)];
    updatedagegroups = [...new Set(updatedagegroups)];
    routines = [...new Set(routines)];
    setLevelOptionArray(updatedLevels);
    setSelectedLevel("")
    setAgeGroupsArray(updatedagegroups);
    setSelectedGroup("")
    setRoutineOptionsArray(routines);
    setSelectedRoutine("")
  };

  // executing this function in handleEventChange funtion
  //  so that it can do filteration of groups and
  // routines when user clicks on eventBtns

  // when user will select level to filter
  
  const handleLevelSelect = (e) => {
    const newlevel = e.target.value;
    console.log(["Setting level",newlevel])
    console.log(selectedLevel)
    setSelectedLevel(newlevel);
    console.log(selectedLevel);
    onLevelChanges(newlevel);
    getAllGroups(selectedEvent,newlevel,selectedGroup,selectedRoutine);
  };

  const onLevelChanges = (level) => {
    console.log("Handling level changes")
    if (allMeetData.cgroups === undefined) {
      return;
    }
    let updatedagegroups = [];
    let routines = [];

    for (let i = 0; i < allMeetData.cgroups.length; i++) {
      let group = allMeetData.cgroups[i];
      if (group.eventname !== selectedEvent && selectedEvent !== ""){ continue }
      if (group.level !== level && level !== ""){ continue }
      updatedagegroups.push(group.agegroup);
      if (group.routines === undefined){continue}
      for (let r = 0; r < group.routines.length; r++) {
        routines.push(group.routines[r].name);
      }
    }

    updatedagegroups = [...new Set(updatedagegroups)];
    routines = [...new Set(routines)];
    setAgeGroupsArray(updatedagegroups);
    setRoutineOptionsArray(routines);
  };
  // running in at the end of handleEventChange so that it will
  // when ever there is change in levels this will run.
  
  const handleGroupSelect = (e) => {
    const newgroup = e.target.value;
    setSelectedGroup(newgroup);
    getAllGroups(selectedEvent,selectedLevel,newgroup,selectedRoutine)
  };

  
  const handleRoutineSelect = (e) => {
    const newroutine = e.target.value;
    setSelectedRoutine(newroutine);
    getAllGroups(selectedEvent,selectedLevel,selectedGroup,newroutine)
  };

  
  return (
    <>
      <div className="mainDashboardPage">
        {matches ? <MobileNavbar /> : <DesktopSideBar />}

        {(loading && (
          <CircularProgress size={"70px"} className="loadingComponent" />
        )) || (
            <div className="dashboardPageContent meetPageContent">
              <div className="headingBar">
                <h5>Pages / Scores</h5>
                <h1>{allMeetData.name}</h1> {/* THIS SHOULD BE THE MEET NAME*/}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button class = "myButton" onClick={handleRefresh}>Refresh Scores</button>
                  <p class = "refreshText">Last refreshed: {lastrefresh} </p>
                </div>
              </div>

              <div className="eventBtnsDiv">
                {eventBtnsArray.map((item) => {
                  return (
                    <button
                      key={item}
                      onClick={() => handleEventChange(item)}
                      className={
                        selectedEvent === item
                          ? "eventBtn blueEventBtn"
                          : "eventBtn"
                      }
                    >
                      {item}
                    </button>
                  );
                })}
              </div>

              <div className="selectBarDiv">
                <div className="selectPart">
                  <div className="selectDivs">
                    <select name="level" onChange={handleLevelSelect} value={selectedLevel}>
                      <option value={""}>All Levels</option>
                      {levelOptionArray.map((item, lIndex) => {
                        return <option key={lIndex}>{item}</option>;
                      })}
                    </select>
                  </div>

                  <div className="selectDivs">
                    <select
                      name="age group"
                      onChange={handleGroupSelect}
                    //  onChange={onGroupSelect}
                    >
                      <option value={""}>All Age Groups</option>
                      {ageGroupsArray.map((item, ageIndex) => {
                        return (
                          <option key={ageIndex} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="selectDivs">
                    <select name="routine" onChange={handleRoutineSelect}>
                      <option value={""}>All Routines</option>
                      {routineOptionssArray.map((item, roindex) => {
                        return (
                          <option key={roindex} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="searchPart">
                  <p>Athlete Search</p>
                  <div className="athleteSearchInpDiv">
                    <input
                      type="text"
                      name="search"
                      className="athleteSearchInp"
                     onChange={searchCompetitor}
                      id=""
                    />
                  </div>
                </div>
              </div>

              <div className="teamsBothDivs" style={{ minHeight: "80vh" }}>
                {noResultsFound && (
                  <div className="teams1stMainDiv">
                    <div className="Team1DivHeadingDiv">
                      <span className="heading">No Results Found</span>
                    </div>
                  </div>
                )}

                {!noResultsFound &&
                  allGroups.map((group, agindex) => {
                    return group.competitors?.length > 0 ? (
                      <div
                        className={"teams1stMainDiv"}
                        id="compDiv"
                        key={agindex}
                      >
                        <div className="Team1DivHeadingDiv">
                          <span className="heading">{group.name}</span>
                        </div>
                        {group.competitors
                          .map((item, gindex) => {
                            return (
                              <div key={gindex} id="eachComp">
                                <div
                                  className={accordianClass}
                                  onClick={openAccordian}
                                >
                                  <div className="nameAndMedalImage">
                                    <div className="totalScoreNum scoreNum">
                                      {item.place}
                                    </div>
                                    <div className="1stDivplayerNames">
                                      {item.name}
                                    </div>
                                  </div>
                                  <div>{item.score}</div>
                                </div>
                                <div className="accordion-content">
                                  {item.routines.map((routine, rindex) => {
                                    return (
                                      <div
                                        className="scoreDetailOfTeamItem"
                                        key={rindex}
                                        id="forOpenAcc"
                                      >
                                        <div className="scoreOfTeamItemLeft">
                                          <div className="rkNo">
                                            {routine.place}
                                          </div>
                                          <div className="heading">
                                            {routine.name}
                                          </div>
                                        </div>
                                        <div className="scoreOfTeamItemRight">
                                          {routine.subscores.map(
                                            (scoreobject, sindex) => {
                                              return (
                                                // THERE SHOULD BE A HEADER HERE of text {scoreobject.header}
                                                <div key={sindex}>
                                                  <div className="scoreNum">
                                                    {scoreobject.title}
                                                  </div>
                                                  <div className="scoreNum">
                                                    {scoreobject.value}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                          <div className="totalScoreNum scoreNum">
                                            {routine.totalscore}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ) : null;
                  })}
              </div>

              <span className="bottomText">
                © 2023 IGNITE GYMNASTICS. All Rights Reserved.{" "}
              </span>
              <br />
              <br />
            </div>
          )}
      </div>
    </>
  );
};

export default Index;
